export default (that) => [
  {
    type: 'seq',
    title: '#',
    width: 55,
    fixed: 'left',
    align: 'center',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    width: 100,
    fixed: 'right',
    align: 'center',
    slots: { default: 'opt' },
  },
  {
    field: 'shipmentNo',
    title: that.$l('form_label_shipmentNo') || '发运单号',
    minWidth: 170,
    fixed: 'left',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'planNos',
    title: that.$l('form_label_planNos') || '补货计划编号',
    minWidth: 170,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    field: 'transportNos',
    title: that.$l('form_label_transportNos') || '外运编号',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalGoodsQty',
    title: that.$l('form_label_totalGoodsQty') || '产品总数量',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalCtnQty',
    title: that.$l('form_label_totalCtnQty') || '总箱数',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalGrossWeight',
    title: that.$l('table_label_totalGrossWeight') || '总毛重(kg)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalNetWeight',
    title: that.$l('table_label_totalNetWeight') || '总净重(kg)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalVolume',
    title: that.$l('table_label_totalVolume') || '总体积(m³)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalBookingVolume',
    title: that.$l('table_label_totalBookingVolume') || '订舱总体积(m³)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'totalCostAmount',
    title: that.$l('table_label_costAmount') || '成本金额',
    width: 140,
    align: 'center',
    formatter: ({ row }) => {
      return [
        row.totalCostAmount || '0',
        row.costCurrencyUnitName || row.costCurrencyUnit,
      ]
        .filter(Boolean)
        .join(' ')
    },
    showHeaderOverflow: true,
  },
  {
    field: 'totalSalesAmount',
    title: that.$l('table_label_salesAmount') || '销售金额',
    width: 140,
    align: 'center',
    formatter: ({ row }) => {
      return [
        row.totalSalesAmount || '0',
        row.salesCurrencyUnitName || row.salesCurrencyUnit,
      ]
        .filter(Boolean)
        .join(' ')
    },
    showHeaderOverflow: true,
  },
  {
    field: 'shipmentStatusName',
    title: that.$l('form_label_status') || '状态',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    field: 'displayCreate',
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    field: 'displayModify',
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
